module.exports = __webpack_public_path__ + "media/images/city/056-milan-cathedral-98044fb7fe8fcfebb8f62a052a769fe6.svg";